import { scrollTargetFor } from './perks-post-comments/comment-entry';

const RENDER_WAIT_INTERVAL_MS = 100;
const RENDER_WAIT_ATTEMPTS = 10;
// How long the cards above the target get to load their media before it is re-checked.
const SETTLE_MS = 800;
const DRIFT_PX = 8;

/** Selector for a post card in the feed; PerksPostComponent stamps every card with its id. */
export const postCardSelector = (postId: string): string =>
  `[data-post-id="${CSS.escape(postId)}"]`;

/**
 * Scrolls the feed to a post card once it has rendered: the post an author or moderator has just
 * published from the submission form (SNGL-7344). Pinned posts hold the top of the feed, so the
 * new post is not necessarily first; the card is found by id, not position.
 *
 * Feed images only take their height once they load, so an image post above the card pushes it
 * down after the first scroll. A second pass re-targets the card once things have settled, unless
 * the reader has scrolled away in the meantime, in which case their position wins.
 */
export const scrollToPost = (postId: string): void => {
  let attempts = 0;
  const attempt = () => {
    const card = document.querySelector(postCardSelector(postId));
    if (!card) {
      if (attempts++ < RENDER_WAIT_ATTEMPTS) window.setTimeout(attempt, RENDER_WAIT_INTERVAL_MS);
      return;
    }
    const target = scrollTargetFor(card, 'start');
    window.scrollTo({ top: target, behavior: 'smooth' });
    window.setTimeout(() => {
      const settled = document.querySelector(postCardSelector(postId));
      if (!settled) return;
      const drifted = scrollTargetFor(settled, 'start');
      const readerStayed = Math.abs(window.scrollY - target) < DRIFT_PX;
      if (readerStayed && Math.abs(drifted - target) > DRIFT_PX) {
        window.scrollTo({ top: drifted, behavior: 'smooth' });
      }
    }, SETTLE_MS);
  };
  attempt();
};
